import debounce from "lodash/debounce";
import { useCallback } from "react";

import { updatePatient } from "../../api/healthcare/PatientApi";
import { Patient } from "../../types/healthcare/PatientTypes";

interface UsePatientAutoSaveOptions {
	patient: Patient | null;
	roomId: string;
}

interface UsePatientAutoSaveResult {
	handleAutoSave: () => void;
}

export function usePatientAutoSave({ patient, roomId }: UsePatientAutoSaveOptions): UsePatientAutoSaveResult {
	const handleAutoSave = useCallback(
		debounce(async () => {
			if (patient && patient.id) {
				try {
					await updatePatient(patient.id, patient);
				} catch {
					// Event name + room id ONLY — an AxiosError here carries the whole patient record in config.data.
					console.error("consult.patient.autosave_failed", { roomId });
				}
			}
		}, 500),
		[patient],
	);

	return { handleAutoSave };
}
